import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { Api } from '@/externals/corner-logis/Swagger';

import { CornerLogis } from '../../helpers';

export const 원스톱_솔루션_상품_쿼리 = createQueryKeys('corner-logis-items', {
  상품_목록_조회: ({ shopID, query }: { shopID: string; query: Api.GetGoodsList.RequestQuery }) => ({
    queryKey: [shopID, query] as const,
    queryFn: () => {
      return CornerLogis.proxy<Api.GetGoodsList.ResponseBody>({
        method: 'GET',
        path: '/api/v1/goods/getGoods/getList',
        params: query,
        shopID,
      });
    },
  }),
});
